import { fromJS } from 'immutable'
import {
  DIVISION_LIST_REQUEST,
  DIVISION_LIST_SUCCESS,
  DIVISION_LIST_FAILURE,
  DIVISION_LIST_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case DIVISION_LIST_REQUEST:
      return state
        .set('isFetching', true)
    case DIVISION_LIST_SUCCESS:
      if (action.payload.ok) {
        return state
          .set('isFetching', false)
          .set('division', fromJS(action.payload.divisions))
          .set('status', action.payload.ok)
      }
      return state
        .set('isFetching', false)
    case DIVISION_LIST_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case DIVISION_LIST_RESET:
      return state
        .set('redirect', false)
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/division/division-list-reducer.js